export class AttendancesFilter {
    classId: number;
    studentCode: string;
    schoolYear: number;
    campusId: number;
    date: any;
    fromDate: any;
    toDate:any;
    page: number;
    max_per_page: number;

    constructor() {
        this.classId = 0;
        this.studentCode = '';
        this.schoolYear = 0;
        this.date = '';
        this.fromDate = '';
        this.toDate = '';
        this.campusId = 0;
        this.page = 1;
        this.max_per_page = 1000;
    }
}


// WEBPACK FOOTER //
// ./src/holiday/models/AttendancesFilter.ts